import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: 'full',
            paddingBlock: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            paddingInline: {base: remCalc(16), md: remCalc(24), lg: remCalc(260)},
            flexDirection: 'column',
            alignItems: 'center',
        },
        newsletterText: {
            textStyle: 'body-xxlarge',
            color: 'text.primary',
            textAlign: {base: 'center', md: 'start'},
        },
        newsletterHeader: {
            textStyle: 'head-medium',
            color: 'text.primary',
            fontWeight: 700,
        },
        newsletterStack: {
            alignItems: {base: 'center', lg: 'flex-start'},
            gap: remCalc(16),
            w: 'full',
            maxW: remCalc(572),
        },
        newsletterFlex: {
            flexDirection: {base: 'column', md: 'row'},
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(24),
            minW: {base: 'auto', xl: remCalc(926)},
        },
        benefitContainer: {
            background: 'background.light',
        },
        newsletterContainer: {
            background: 'background.light-blue',
        },
        preFooterContainer: {
            gap: '0',
        },
        benefitBarHeader: {
            textStyle: 'body-medium',
            color: 'text.default',
            fontWeight: 700,
        },
        benefitBarText: {
            textStyle: 'body-small',
            color: 'text.default',
        },
        benefitBarIcons: {
            color: 'background.dark',
            boxSize: ['iconsSize.xlarge'],
            alignSelf: 'center',
        },
        benefitBarStack: {
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(16),
        },
        benefitBarBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: remCalc(12),
            textAlign: 'center',
        },
        benefitBarContainer: {
            w: 'full',
            justifyContent: 'space-between',
            alignItems: 'center',
            display: {base: 'none', md: 'flex'},
        },
        benefitBarSwiper: {
            display: {base: 'block', md: 'none'},
        },
        newsletterButton: {
            w: 'full',
            maxW: {base: 'auto', lg: remCalc(330)},
            alignSelf: 'center',
        },
    },
}
